/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M17.5,11.5 C17.5,8.186 14.812,5.5 11.5,5.5 C8.186,5.5 5.5,8.186 5.5,11.5 C5.5,14.294 7.413,16.636 10,17.303 L10,18.5 L13,18.5 L13,17.303 C15.585,16.636 17.5,14.294 17.5,11.5 Z" />
      <path d="M12,22.5 L11,22.5" />
      <path d="M13,20.5 L10,20.5" />
      <path d="M11.5,1.5 L11.5,3.5" />
      <path d="M21.5,11.5 L19.5,11.5" />
      <path d="M1.5,11.5 L3.5,11.5" />
      <path d="M3.721,3.722 L5.843,5.844" />
      <path d="M19.277,3.722 L17.155,5.844" />
    </g>
  </svg>
);

export default Icon;
